module.exports = __webpack_public_path__ + "img/logo_footer.2729c3ef.svg";